// Vercel Web Analytics and Speed Insights fetch their scripts from /_vercel/*,
// which exists only on a Vercel deployment. Everywhere else that path hits the
// SPA's index.html fallback and the browser parses HTML as JS: "Unexpected
// token '<'" at boot (#450). Both collect on production only anyway.
const PRODUCTION_HOSTS = new Set([
  'socialworktestprepacademy.com',
  'www.socialworktestprepacademy.com',
]);

export function isProductionHost(
  hostname: string | undefined = typeof window === 'undefined' ? undefined : window.location.hostname,
): boolean {
  return hostname !== undefined && PRODUCTION_HOSTS.has(hostname);
}
